var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.warningText)?_c('Card',{staticClass:"my-3 mx-auto elevation-3 pa-3",attrs:{"color":_vm.severity || '#FFFEED'}},[_vm._v(_vm._s(_vm.warningText))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }